var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":28,"height":28,"viewBox":[0, 0, 28, 28],"xml:space":"preserve","preserveAspectRatio":"xMidYMid meet"}},[_c('path',{attrs:{"id":"backBlack","fill":"#222222","d":"M24.5 12.8333H7.96833L12.145 8.645L10.5 7L3.5 14L10.5 21L12.145 19.355L7.96833 15.1667H24.5V12.8333Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }